import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'routes';
import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown/index';
import { getUserName, isAdminUser } from 'utils/index';
import { isMyVideosVisibleSelector, getSavedVideosFeatureSelector } from 'common/selectors';
import { faUser } from '@fortawesome/pro-solid-svg-icons';

const ProfileMenu = ({ withSavedVideos, withMyVideos }) => {
  const { t } = useTranslation();
  const username = getUserName();

  if (!username) {
    return null;
  }

  return (
    <SimpleDropDown
      data-e2e="ct-profile-menu"
      title={username}
      icon={faUser}
      className="ct-control-bar__element"
      left={true}
      aria-label={t('user-profile-menu')}
    >
      {isAdminUser() && (
        <SimpleDropDownElement onClick={() => window.location.href = appRoutes.administration}>
          {t('administration')}
        </SimpleDropDownElement>
      )}
      {withMyVideos && (
        <SimpleDropDownElement data-e2e="ct-profile-menu_my-videos-item" onClick={() => window.location.href = '/my-videos'}>
          {t('my_uploads')}
        </SimpleDropDownElement>
      )}
      {withSavedVideos && (
        <SimpleDropDownElement data-e2e="ct-profile-menu_favourite-videos-item" onClick={() => window.location.href = '/saved-videos/1/?sort=recently_added'}>
          {t('saved_uploads')}
        </SimpleDropDownElement>
      )}
    </SimpleDropDown>
  );
};

export const ProfileMenuDecorated = connect((state) => ({
  withSavedVideos: getSavedVideosFeatureSelector(state),
  withMyVideos: isMyVideosVisibleSelector(state),
}))(ProfileMenu);
